'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var I18nUniversal = function () {
  function I18nUniversal() {
    (0, _classCallCheck3.default)(this, I18nUniversal);

    if (__CLIENT__) {
      var i18n = require('i18n-client');
      i18n.changeLanguage(window.__i18n.locale);
      i18n.addResourceBundle('en', 'common', window.__i18n.resources.en, true);
      i18n.addResourceBundle(window.__i18n.locale, 'common', window.__i18n.resources[window.__i18n.locale], true);
      _moment2.default.locale(window.__i18n.locale);
      this.i18n = i18n;
      this.locale = window.__i18n.locale;
    } else {
      this.i18n = require('./i18n-server');
      this.setLocale('en');
    }
    return this;
  }

  (0, _createClass3.default)(I18nUniversal, [{
    key: 'setI18n',
    value: function setI18n(i18n) {
      this.i18n = i18n;
      return this;
    }
  }, {
    key: 'getI18n',
    value: function getI18n() {
      return this.i18n;
    }
  }, {
    key: 'setLocale',
    value: function setLocale(locale) {
      this.locale = locale;
      _moment2.default.locale(locale);
      this.i18n.changeLanguage(locale);
      return this;
    }
  }, {
    key: 'getLocale',
    value: function getLocale() {
      return this.locale;
    }
  }, {
    key: 'getT',
    value: function getT() {
      return this.i18n.getFixedT();
    }
  }]);
  return I18nUniversal;
}();

exports.default = new I18nUniversal();
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/i18n-universal.js
// module id = 56
// module chunks = 1